import React, { useState, useEffect } from 'react';
import intl from '$intl';
import { IonContent } from '@ionic/react';

import { Div, FONT, H2, SPACE, WEIGHT } from '$gstyles';
import { Button } from '$gcomponents/primitives';
import Footer from '$gcomponents/widgets/footer';

import { format } from '$gbusiness/helpers/date';
import { DATE_FORMATS } from '$gbusiness/enums';
import FactoryModel from '$fbusiness/models/factory';

import InvoiceModel from '$fbusiness/models/invoice';
import OrderDetails from '$fcomponents/orderDetails';
import { KEYS as ORDER_STATUS } from '$fbusiness/enums/options/orderStatus';
import { KEYS as INVOICE_STATUS, KEYS } from '$fbusiness/enums/options/invoiceStatus';
import { useDispatch } from 'react-redux';
import { invoiceActions } from '$fbusiness/redux/invoice';
import CurrentStateModel from '$fbusiness/models/currentState';

interface InvoiceDetailsProps {
  invoice: InvoiceModel;
  currentState: CurrentStateModel;
  factory: FactoryModel;
  onClose: Function;
}

const MODES = {
  PACKING: 'packing-mode',
  INVOICE: 'invoice-mode',
  INITIAL: '',
};

const InvoiceDetails: React.FC<InvoiceDetailsProps> = ({ currentState, factory, invoice, onClose }) => {
  const [invoiceMode, setInvoiceMode] = useState(MODES.INITIAL);
  const dispatch = useDispatch();
  useEffect(() => {
    if (!invoiceMode) return;
    window.print();
  }, [invoiceMode]);

  const { invoiceNumber, orderId, order } = invoice;
  const hasOrder = !!invoice.orderId;

  const onPrintInvoice = () => {
    if (invoiceMode === MODES.INVOICE) {
      window.print();
      return;
    }
    setInvoiceMode(MODES.INVOICE);
  };

  const onPayInvoice = async () => {
    await dispatch(invoiceActions.updateInvoice({ id: invoice.id, status: INVOICE_STATUS.PAYMENT_SENT }));
    onClose(true);
  };

  return (
    <>
      <IonContent className={invoiceMode}>
        <Div padding={SPACE.XLARGE}>
          <H2 padding={`${SPACE.LARGE} 0 ${SPACE.MEDIUM} 0`} fontWeight={WEIGHT.BOLD}>
            <div className="invoice-print-block">
              {intl('SCREEN.INVOICES.TITLE_PRINT', { invoiceNumber })}
              {invoice?.status === KEYS.PAID && <div className="paid">(PAID)</div>}
            </div>
            {hasOrder && (
              <div className="packing-print">{intl('SCREEN.ORDER.TITLE_PACKING', { orderId })}</div>
            )}
          </H2>
          {hasOrder && (
            <Div fontSize={FONT.MEDIUM} className="center">
              {intl('SCREEN.ORDER.DATE')}: {format(invoice?.order?.createdAt || '', DATE_FORMATS.SLASH)}
            </Div>
          )}

          <OrderDetails currentState={currentState} factory={factory} invoice={invoice} order={order} />
        </Div>
      </IonContent>
      <Footer justifyContent="space-around" className="no-print">
        <Button variant="outlined" className="" onClick={() => onClose()}>
          {intl('BUTTON.CANCEL')}
        </Button>
        {order?.status === ORDER_STATUS.CLOSED && invoice.status === INVOICE_STATUS.OPEN ? (
          <Button className="third" onClick={onPayInvoice}>
            {intl('BUTTON.PAYMENT_SENT')}
          </Button>
        ) : (
          <Button className="third" onClick={onPrintInvoice}>
            {intl('BUTTON.PRINT_INVOICE')}
          </Button>
        )}
      </Footer>
    </>
  );
};

export default InvoiceDetails;
